import { useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { noop } from "@client/shared/constants";
import { Grid, FilterComponent } from "@client/shared/components";
import { getUserData, getRCAccountId } from "@client/utils";
import SimulateNotification from "../shared/simulated-notification";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import CloseIcon from "@mui/icons-material/Close";
import NotificationCard from "../shared/card";
import BulkEdit from "./bulk-edit";
import style from "./style";
import CircularProgress from "@mui/material/CircularProgress";

const NotificationView = ({
  handleDuplicateClick = noop,
  isLoading = false,
  isDuplicating = false,
  isDeleting = false,
  areAllSelected = false,
  selectedRows = [],
  preference = {},
  handleDeleteConfirmation = noop,
  isDeleteDisabled = false,
  cardView = false,
  isFiltering = false,
  handleExport = noop,
  columns = [],
  entries = [],
  filters = [],
  handleFilterClose = noop,
  onGridReady = noop,
  handlePageNumberChange = noop,
  handlePageSizeChange = noop,
  handleSelectionChange = noop,
  handleAllSelectionChange = noop,
  handleSorting = noop,
  pageNumber = 1,
  pageSize = 5,
  totalEntries = 0,
  handleBulkEdit = noop,
  handleDelete = noop,
  handleCardView = noop,
  handleFiltering = noop,
  dialog = {},
  rowsBeingDuplicated = [],
  handleCancelDuplicate = noop,
  handleDuplicateConfirmation = noop,
  toggleAll = false,
  handleToggleAllClick = noop,
  rowsBeingToggled = [],
  handleCancelToggle = noop,
  handleToggleConfirmation = noop,
  handleStatusChange = noop,
  handleFilterChange = noop,
  bulkEditOnClose = noop,
  bulkEditOnPreferenceChange = noop,
  bulkEditOnSave = noop,
  countryList = [],
  handleDuplicated = noop,
  handleClose = noop,
  handleDuplicateClose = noop,
  handleDuplicate = noop,
  onPreferenceChange = noop,
  order = null,
  orderBy = "",
  disabled = false,
  handleSuccess = noop,
  appliedFilters = [],
  onFilterReady = noop,
  loadedExtension = false,
}) => {
  const userData = (getUserData() || {}).user || {};
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      <Box>
        <Box sx={style.pageHeadingWrapper}>
          <Typography sx={style.pageHeading} variant="h5">
            Notifications
          </Typography>
          <Typography sx={style.pageHeadingCaption} variant="caption">
            Create, edit and manage notifications.
          </Typography>
          <span style={style.pageHeadingMarker}></span>
        </Box>
      </Box>
      <Box sx={style.actionWrapper}>
        <Box sx={style.actionButtonLeft}>
          <Button
            color="primary"
            // disabled={state.isEditing}
            sx={true && { ...style.textColor }}
            onClick={() => {
              navigate(
                `${location.pathname}${
                  (location.pathname || "").endsWith("/") ? "" : "/"
                }create`
              );
            }}
            startIcon={
              <img
                alt=""
                src={
                  // state.isEditing
                  false ? "/assets/plus-grey.svg" : "/assets/plus.svg"
                }
              />
            }
            variant="outlined"
          >
            <Typography variant="button" noWrap>
              New Notification
            </Typography>
          </Button>
          <Button
            sx={
              !(
                isLoading ||
                isDuplicating ||
                areAllSelected ||
                selectedRows.length === 0
              )
                ? { ...style.action, ...style.textColor }
                : { ...style.action }
            }
            color="primary"
            onClick={handleDuplicateClick}
            variant="outlined"
            disabled={
              isLoading ||
              isDuplicating ||
              areAllSelected ||
              selectedRows.length === 0
            }
            startIcon={
              <img
                alt=""
                src={
                  isLoading ||
                  isDuplicating ||
                  areAllSelected ||
                  selectedRows.length === 0
                    ? "/assets/duplicate-disabled.svg"
                    : "/assets/duplicate.svg"
                }
              />
            }
          >
            <Typography variant="button">Duplicate</Typography>
          </Button>
          <Box sx={{ marginLeft: "16px" }}>
            <SimulateNotification
              accountId={getRCAccountId()}
              classes={{
                button: "action",
              }}
              disabled={
                isLoading ||
                // isEditing ||
                areAllSelected ||
                selectedRows.length !== 1
              }
              extension={
                (
                  entries.find((item) => item.id === selectedRows[0]) || {}
                )?.users?.split(",")[0] === "All Users"
                  ? userData.extensionId
                  : (
                      entries.find((item) => item.id === selectedRows[0]) || {}
                    )?.users?.split(",")[0]
              }
              isStatusOff={
                !entries.filter((entry) => entry.id === selectedRows[0])[0]
                  ?.enabled
              }
              handleSuccess={handleSuccess}
              notification={
                entries.find((item) => item.id === selectedRows[0]) || {}
              }
            />
          </Box>
          <Button
            sx={
              !(isLoading || (selectedRows.length < 2 && !areAllSelected))
                ? { ...style.action, ...style.textColor }
                : { ...style.action }
            }
            color="primary"
            variant="outlined"
            disabled={
              isLoading ||
              (selectedRows.length < 2 && !areAllSelected) ||
              areAllSelected
            }
            onClick={() => {
              if (selectedRows.length < 2 && !areAllSelected) {
                return;
              }

              handleBulkEdit();
            }}
            startIcon={
              <img
                alt=""
                src={
                  isLoading ||
                  (selectedRows.length < 2 && !areAllSelected) ||
                  areAllSelected
                    ? "/assets/edit-disabled.svg"
                    : "/assets/edit.svg"
                }
              />
            }
          >
            <Typography variant="button" noWrap>
              Bulk Edit
            </Typography>
          </Button>
          <Button
            color="error"
            // classes={{
            //   root: clsx("action", {
            //     "border-error": !isDeleteDisabled,
            //   }),
            //   label: isDeleteDisabled ? "" : "color-error",
            // }}
            sx={style.action}
            onClick={() => {
              if (!preference.delete) {
                handleDelete();
              } else {
                handleDeleteConfirmation();
              }
            }}
            variant="outlined"
            disabled={isDeleteDisabled}
            startIcon={
              <img
                alt=""
                src={
                  isDeleteDisabled
                    ? "/assets/trash-disabled.svg"
                    : "/assets/trash.svg"
                }
              />
            }
          >
            <Typography variant="button">Delete</Typography>
          </Button>
        </Box>
        <Box sx={{ ...style.actionButtonRight, gap: "24px" }}>
          <img
            alt="Switch to card view"
            style={!disabled ? { cursor: "pointer" } : style.disabled}
            onClick={() => {
              handleCardView();
            }}
            src={
              !cardView
                ? isLoading || disabled
                  ? "/assets/cards-disabled.svg"
                  : "/assets/cards.svg"
                : isLoading || disabled
                ? "/assets/grid-view-disabled.svg"
                : "/assets/grid-view.svg"
            }
          />
          {/* <img
            alt="Filter data"
            // className={clsx("action", {
            //   "c-pointer": !(isLoading || isFiltering),
            // })}
            onClick={() => {
              if (isLoading) {
                return;
              }
              handleFiltering();
            }}
            src={
              isLoading ? "/assets/filter-disabled.svg" : "/assets/filter.svg"
            }
          /> */}
          <FilterComponent
            filterConfig={filters}
            onFilterApply={handleFilterChange}
            isFiltering={isFiltering}
            appliedFilters={appliedFilters}
            disabled={disabled}
            onFilterClose={handleFilterClose}
            onReady={onFilterReady}
          />
          <img
            alt="Export data"
            style={!disabled ? { cursor: "pointer" } : style.disabled}
            onClick={handleExport}
            src={
              isLoading || disabled
                ? "/assets/export-disabled.svg"
                : "/assets/export.svg"
            }
          />
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Switch
              className="action"
              checked={toggleAll}
              disabled={isLoading || disabled}
              label="Toggle All"
              onChange={handleToggleAllClick}
            />
            <Typography
              sx={
                !disabled
                  ? { fontWeight: "bold", color: "grey.600" }
                  : { fontWeight: "bold", color: "grey.400" }
              }
              variant="subtitle2"
            >
              Toggle All
            </Typography>
          </Box>
        </Box>
      </Box>
      <Paper elevation={1}>
        <Grid
          cardView={cardView}
          renderCard={({ row, onSelectionChange }) => {
            return (
              <NotificationCard
                areAllSelected={areAllSelected}
                notification={row}
                onSelectionChange={(row) => onSelectionChange(row.id)}
                onToggle={handleStatusChange}
                onMoreActionsChange={(selectedOption) => {
                  if (selectedOption.actionType === "Edit") {
                    navigate(`/notifications/${row.id}/edit`);
                  } else if (selectedOption.actionType === "Duplicate") {
                    handleDuplicated(row);
                    setTimeout(handleDuplicateClick, 400);
                  }
                }}
                onCardClick={() => navigate(`/notifications/${row.id}/edit`)}
                selectedRows={selectedRows}
              />
            );
          }}
          columns={columns}
          rows={entries || []}
          filters={filters}
          isFiltering={isFiltering}
          isLoading={isLoading}
          hasLoader
          keepSelection
          onFilterClose={handleFilterClose}
          onReady={onGridReady}
          onPageNumberChange={handlePageNumberChange}
          onPageSizeChange={handlePageSizeChange}
          onSelectionChange={handleSelectionChange}
          onSelectAll={handleAllSelectionChange}
          onSortChange={handleSorting}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalRows={totalEntries}
          order={order}
          orderBy={orderBy}
          disabled={disabled}
          classes={{
            container: style.tablePaper,
            bgColor: areAllSelected && !cardView && style.bgColor,
          }}
        />
      </Paper>
      <Dialog open={dialog.delete}>
        <DialogContent
          sx={{ minHeight: "200px", minWidth: "100px", maxWidth: "400px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Delete Notifications?</Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={handleClose}
              />
            </IconButton>
          </Box>
          <Typography variant="subtitle2">
            Are you sure you want to delete{" "}
            {selectedRows.length > 1 ? "these" : "this"}{" "}
            {selectedRows.length > 1 ? "items" : "item"}. You will not be able
            to recover {selectedRows.length > 1 ? "these" : "this"}{" "}
            {selectedRows.length > 1 ? "notifications" : "notification"} after
            you delete {selectedRows.length > 1 ? "them" : "it"}.
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "32px",
            }}
          >
            <Checkbox
              checked={preference.delete}
              onChange={(event) => onPreferenceChange(event, 'delete')}
            />
            <Typography variant="subtitle2">
              Do not show this message again.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{ color: "grey.600", mr: 4 }}
            variant="text"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirmation}
            variant="contained"
            color="error"
            disabled={isDeleting}
          >
             {isDeleting && (
							<CircularProgress size={18} sx={{ position: 'absolute' }} />
						)}
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={dialog.duplicate}>
        <DialogContent
          sx={{ minWidth: 200, minHeight: 200, maxWidth: "400px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 4,
            }}
          >
            <Typography variant="h6">{`Duplicate ${
              rowsBeingDuplicated.length > 0 ? "Notification" : "Notifications"
            }?`}</Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={handleCancelDuplicate}
              />
            </IconButton>
          </Box>

          <Typography variant="body1">{`Are you sure you want to duplicate ${
            rowsBeingDuplicated.length > 0
              ? "this notification"
              : "these notifications"
          }? This
         action cannot be undone and you will receive duplicate notifications.`}</Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "32px",
            }}
          >
            <Checkbox
              checked={preference.duplicate}
              onChange={(event) => onPreferenceChange(event, 'duplicate')}
            />
            <Typography variant="subtitle2">
              Do not show this message again.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelDuplicate}
            sx={{ color: "grey.600", mr: 4 }}
            variant="text"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDuplicateConfirmation}
            variant="contained"
            color="secondary"
            disabled={isDuplicating}
          >
            {isDuplicating && (
							<CircularProgress size={18} sx={{ position: 'absolute' }} />
						)}
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* duplicate dialog */}
      <Dialog open={dialog.duplicateSuccess}>
        <DialogContent
          sx={{ minHeight: "200px", minWidth: "100px", maxWidth: "350px" }}
        >
          <Typography variant="h6">Notifications Duplicated!</Typography>
          <Typography variant="subtitle2">
            Your selected notifications have been duplicated.
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "32px",
            }}
          >
            <Checkbox
              checked={preference.duplicateSuccess}
              onChange={(event) => onPreferenceChange(event, 'duplicateSuccess')}
            />
            <Typography variant="subtitle2">
              Do not show this message again.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDuplicateClose}
            sx={{ color: "grey.600", mr: 4 }}
            variant="text"
          >
            Cancel
          </Button>
          <Button onClick={handleDuplicate} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dialog.toggle.all || dialog.toggle.rows} maxWidth="md">
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" sx={{ mt: 2 }}>
              {dialog.toggle.rows
                ? rowsBeingToggled.length > 0 &&
                  rowsBeingToggled[rowsBeingToggled.length - 1].enabled
                  ? "Turn Off Notification?"
                  : "Turn On Notification?"
                : "Toggle All Notifications?"}
            </Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={handleCancelToggle}
              />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ minWidth: 432, mt: 2 }}>
          <Typography>
            {dialog.toggle.rows
              ? rowsBeingToggled.length > 0 &&
                rowsBeingToggled[rowsBeingToggled.length - 1].enabled
                ? `Are you sure you want to disable this notification and turn it
                 off? You will not see notifications when triggers are 
                 met for this notification.`
                : `Are you sure you want to enable this notification and turn it 
                on? You will begin to receive notifications when triggers are 
                met for this notification.`
              : "Are you sure you want to toggle all notifications?"}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginTop: "18px",
            }}
          >
            <Checkbox
              checked={preference.toggle}
              onChange={(event) => onPreferenceChange(event, 'toggle')}
            />
            <Typography variant="subtitle1">
              Do not show this message again.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 5 }}>
          <Button
            onClick={handleCancelToggle}
            variant="text"
            sx={{ color: "grey.600", mr: 4 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleToggleConfirmation}
            variant="contained"
            color="secondary"
          >
            {dialog.toggle.rows
              ? rowsBeingToggled.length > 0 &&
                rowsBeingToggled[rowsBeingToggled.length - 1].enabled
                ? "Turn Off"
                : "Turn On"
              : dialog.toggle.all
              ? "Toggle All"
              : ""}
          </Button>
        </DialogActions>
      </Dialog>

      {/* {state.dialog.bulkEdit && (
        <BulkEdit
          areAllSelected={state.areAllSelected}
          confirmEdit={state.preference.bulkEdit}
          countryList={countries || []}
          onClose={() => {
            setState((prevState) => ({
              ...prevState,
              dialog: {
                ...prevState.dialog,
                bulkEdit: false,
              },
            }));
          }}
          onPreferenceChange={(event) => {
            const checked = event.currentTarget.checked;
            setState((prevState) => {
              const updatedPreferences = {
                ...prevState.preference,
                bulkEdit: !checked,
              };

              updatePreferences(updatedPreferences);
              return {
                ...prevState,
                preference: updatedPreferences,
              };
            });
          }}
          onSave={() => {
            fetchNotifications();
            setState((prevState) => ({
              ...prevState,
              dialog: {
                ...prevState.dialog,
                bulkEdit: false,
              },
            }));
          }}
          selectedRows={state.selectedRows}
        />
      )} */}
      {dialog.bulkEdit && (
        <BulkEdit
          areAllSelected={areAllSelected}
          confirmEdit={preference.bulkEdit}
          countryList={countryList || []}
          onClose={bulkEditOnClose}
          onPreferenceChange={bulkEditOnPreferenceChange}
          onSave={bulkEditOnSave}
				selectedRows={selectedRows}
				entries={entries}
        loadedExtension={loadedExtension}
        />
      )}
    </>
  );
};

export default NotificationView;
